import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
    forwardRef,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ed-switch',
    templateUrl: './ed-switch.component.html',
    styleUrls: ['./ed-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EdSwitchComponent),
            multi: true,
        },
    ],
})
export class EdSwitchComponent implements ControlValueAccessor {
    @Input() label: string = '';
    @Input() disabled: boolean = false;
    @Input() size: 'small' | 'medium' | 'large' = 'medium';

    @Output() checkedChange = new EventEmitter<boolean>();

    checked: boolean = false;

    private onChange: (value: boolean) => void = () => {};
    private onTouched: () => void = () => {};

    // Gestion manuelle du toggle
    onToggle(value: boolean): void {
        this.checked = value;
        this.checkedChange.emit(value);
        this.onChange(value);
        this.onTouched();
    }

    // ---- ControlValueAccessor ----
    writeValue(value: boolean): void {
        this.checked = value ?? false;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
